export { enUS } from './locale_enUS';
export { deDE } from './locale_deDE';
export { itIT } from './locale_itIT';
export { ptBR } from './locale_ptBR';
export { daDK } from './locale_daDK';
export { trTR } from './locale_trTR';
